import { render, staticRenderFns } from "./surchargers.vue?vue&type=template&id=6118d7f0&"
import script from "./surchargers.vue?vue&type=script&lang=js&"
export * from "./surchargers.vue?vue&type=script&lang=js&"
import style0 from "./surchargers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports